import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import CustomDropdownFilter from 'src/components/custom-cells/CustomDropdownFilter';

const options = [
  { text: 'Local Upload (OCR)', operator: 'Local Upload' },
  { text: 'Email (OCR)', operator: 'Email' },
  { text: 'SFTP (OCR)', operator: 'SFTP' },
];

export const SourceFilterMenu = (props: GridColumnMenuProps) => (
  <CustomDropdownFilter {...props} option={options} />
);
